module.exports = __webpack_public_path__ + "img/n8.3d50c6a6.jpg";